import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskReserveCreateInterface } from '../definitions/task-reserve-create-interface';
import { TaskReserveCreateRequestInterface } from '../definitions/task-reserve-create-request-interface';

@Injectable()
export class TaskReserveCreateService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public create(taskId: string, data: TaskReserveCreateRequestInterface): Observable<TaskReserveCreateInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/reserves`;

    return this.client.post<TaskReserveCreateInterface>(url, data).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
